import BaseService from './baseService';

export default {
  getFamiliaCAO() {
    return BaseService.get("familia/listarCAO");
  },
  
  getFamiliaListar(descricao) {
    return BaseService.get("familia/listar?descricao="+descricao);
  },

  getListaFamiliaCatalagoMat(descricao){

    return BaseService.get("familia/catalogo?descricao="+descricao);

  },
  salvar(model) {
    return BaseService.post("familia/cadastrarfamiliasolicitacao", model);
  },

  atualizar(model) {
    return BaseService.post("familia/atualizarfamiliasolicitacao", model);
  },

  aprovarRejeitar(itemLista) {
    return BaseService.post("familia/aprovarRejeitar",itemLista)
  },

  delete(model) {
    const parametros = "idFornecSolicitacao="+ model.idFornecSolicitacao + "&idFamiliaFornec="+model.idFamiliaFornec;
    return BaseService.delete("familia/excluirfamiliasolicitacao?"+parametros);
  },
  getMotivosIndeferimento(codGrupo, numFamilia) {
    return BaseService.get("familia/listarmotivosrejeicao?codGrupo=" + codGrupo + "&numFamilia=" + numFamilia);
  },
  getAllMotivosIndeferimento() {
    return BaseService.get("familia/listartodosmotivosrejeicao");
  },

  validaFamiliaCadastrador(codGrupo, numFamilia, numCgcFornec) {
    return BaseService.get("familia/validaFamiliaCadastrador?codGrupo=" + codGrupo + "&numFamilia=" + numFamilia + "&numCgcFornec=" + numCgcFornec);
  }

};
